// extracted by mini-css-extract-plugin
export default {"componentWrapper":"DocumentsTable_componentWrapper__dQ4IM","loaderWrapper":"DocumentsTable_loaderWrapper__duDhj","tableWrapper":"DocumentsTable_tableWrapper__0coW5"};